import React from 'react';
import { IconFont, useFocusIdx } from '@bay-email/editor';
import { RadioGroupField } from '../../../components/Form';

const options = [
	{
		value: 'left',
		label: <IconFont iconName='icon-align-left' />,
	},
	{
		value: 'center',
		label: <IconFont iconName='icon-align-center' />,
	},
	{
		value: 'right',
		label: <IconFont iconName='icon-align-right' />,
	},
];

export function Align({ inline }: { inline?: boolean }) {
	const { focusIdx } = useFocusIdx();

	return (
		<RadioGroupField
			label={t('Align')}
			name={`${focusIdx}.attributes.align`}
			options={options}
			type='button'
		/>
	);
}
